// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Core from "@material-ui/core";
import * as App_Button$DvmAdminFrontendFr from "../../../common/components/button/App_Button.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../common/App_Typography.bs.js";
import * as Messages_Bonuses_Manage$DvmAdminFrontendFr from "../../../intl/messages/bonuses/Messages_Bonuses_Manage.bs.js";
import * as Messages_Orders_Derogate$DvmAdminFrontendFr from "../../../intl/messages/orders/Messages_Orders_Derogate.bs.js";

function Bonuses_Manage_Derogate(Props) {
  var manageCallDerogate = Props.manageCallDerogate;
  var intl = ReactIntl.useIntl();
  return React.createElement(Core.Grid, {
              children: null,
              container: true,
              justifyContent: "space-between",
              spacing: 1
            }, React.createElement(Core.Grid, {
                  children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                        style: {
                          fontWeight: "bold"
                        },
                        children: intl.formatMessage(Messages_Bonuses_Manage$DvmAdminFrontendFr.derogationConfirmation),
                        variant: "bodyBig"
                      }),
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                        onClick: (function (param) {
                            Curry._1(manageCallDerogate, undefined);
                          }),
                        label: intl.formatMessage(Messages_Orders_Derogate$DvmAdminFrontendFr.derogateButton),
                        size: "medium"
                      }),
                  item: true
                }));
}

var make = Bonuses_Manage_Derogate;

export {
  make ,
}
/* react Not a pure module */
